import {useEffect} from 'react';
import {DialogContent, Stack, Typography} from '@mui/material';
import {BaseDialog} from '@resurs-internal/mui';
import {Link} from '@mui/material';
import {useDialog, useTranslate} from 'hooks';
import {analytics} from '@resurs-internal/core';
import {Button} from '@mui/material';
import {useTrustpilotReview} from '@resurs-internal/rb-app-api';
import {trustpilotReview} from './helpers';

export const TrustpilotReviewDialog = () => {
  const dialog = useDialog<{tags: string[]}>('trustpilot-review');
  const translate = useTranslate();
  const {data: trustpilot} = useTrustpilotReview({
    enabled: dialog.open,
    body: {tags: dialog.state?.tags},
  });

  const handleClose = () => {
    dialog.onClose();
    trustpilotReview.suppress({days: 7});
  };
  const handleReviewClick = () => {
    analytics.click({name: 'trustpilot_review_link_click'});

    window.setTimeout(() => {
      dialog.onClose();
    }, 1);
  };

  useEffect(
    function trackDialogShown() {
      if (!dialog.open) return;

      analytics.log('trustpilot_review_dialog_shown');
    },
    [dialog.open],
  );

  return (
    <BaseDialog
      actions={[
        {
          title: translate('trustpilot.review-link.cancel'),
          onClick: handleClose,
          color: 'secondary',
        },
      ]}
      maxWidth={'sm'}
      open={dialog.open}
      onClose={handleClose}>
      <DialogContent
        sx={{
          display: 'flex',
          alignItems: 'center',
          minWidth: {xs: '100%', md: '600px'},
          p: 'unset',
        }}>
        <Stack
          alignItems={'center'}
          textAlign={'center'}
          padding={4}
          gap={2}
          width={'100%'}>
          <Typography variant={'h4'}>
            {translate('trustpilot.review-link.header')}
          </Typography>
          <Typography variant={'body1'}>
            {translate('trustpilot.review-link.body')}
          </Typography>
          <Link
            href={trustpilot?.link ?? ''}
            target="_blank"
            rel="noopener noreferrer">
            <Button
              color="secondary"
              variant="contained"
              onClick={handleReviewClick}>
              {translate('trustpilot.review-link.action')}
            </Button>
          </Link>
        </Stack>
      </DialogContent>
    </BaseDialog>
  );
};
